import { render, staticRenderFns } from "./AdminTableSubheader.vue?vue&type=template&id=c25bce7a&scoped=true"
import script from "./AdminTableSubheader.vue?vue&type=script&lang=js"
export * from "./AdminTableSubheader.vue?vue&type=script&lang=js"
import style0 from "./AdminTableSubheader.vue?vue&type=style&index=0&id=c25bce7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c25bce7a",
  null
  
)

export default component.exports